import { render, staticRenderFns } from "./listCounter.pug?vue&type=template&id=2bae5ed6&lang=pug&"
import script from "./listCounter.js?vue&type=script&lang=js&"
export * from "./listCounter.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bae5ed6')) {
      api.createRecord('2bae5ed6', component.options)
    } else {
      api.reload('2bae5ed6', component.options)
    }
    module.hot.accept("./listCounter.pug?vue&type=template&id=2bae5ed6&lang=pug&", function () {
      api.rerender('2bae5ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/list/modules/counter/index.vue"
export default component.exports